import { HashRouter as Router, Route, Routes } from 'react-router-dom';

import Header from './components/header/header';
import Home from './components/home/home';
import Menu from './components/menu/menu';
import ContactUs from './components/contact-us/contact-us';
import Footer from './components/footer/footer';

import './App.scss';

function App() {
  return (
    <Router>
      <div>
        <Header title="JK's Chinese Takeaway"/>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/contact-us" element={<ContactUs />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

